import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-multimedia-tile-box',
  imports: [],
  templateUrl: './multimedia-tile-box.component.html',
  styleUrl: './multimedia-tile-box.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultimediaTileBoxComponent {}
